module.exports = __webpack_public_path__ + "img/water.e6eb2179.svg";